import {
  Typography,
  Box,
  MenuItem,
  Button,
  Grid,
  Select,
  FormControl,
  Checkbox,
  InputLabel,
  Autocomplete,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import classes from "./propertys.module.css";
import { ListFilterIcon, WhiteSearchIcon } from "../../Assets/Icons/icons";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import MyTableContainer from "./MyTableContainer";
import { useDispatch, useSelector } from "react-redux";
import { FaFilterCircleXmark } from "react-icons/fa6";
import {
  getAllFiltersList,
  getAllProperties,
  getFeildsList,
  saveInputFilter,
  saveSelectedDate,
  saveSortOrder,
} from "../../Redux/Actions/propertyAction";
import { range } from "../../Utilities/commonConstants";
import moment from "moment";

let arr = [1, 2, 3, 4, 5];

let test_users = [
  {
    name: "Manoj",
  },
  {
    name: "Krishna",
  },
  {
    name: "Sri",
  },
  {
    name: "Arun Prasanth",
  },
  {
    name: "Mythili",
  },
  {
    name: "Shiva",
  },
  {
    name: "Trisha",
  },
  {
    name: "Bharath kumar",
  },
];

const PropertyIndex = () => {
  // const [inputs, setInputs] = useState({
  //   category: [],
  //   property_type: [],
  //   location: [],
  //   city: [],
  //   posted_by: [],
  //   area: [],
  //   price: [],
  //   status: [],
  //   owner_type: [],
  // });
  const statusList = [
    "Active",
    "Under_Verification",
    "Pending_Approval",
    "Expired",
    "Deleted",
    "Sold",
    "Deactivated",
    "Drafted",
  ];
  const [errorAlert, setErrorAlert] = useState(false);
  const [pagination, setPagination] = useState(1);
  const [selectedDate, setSelectedDate] = useState();
  // const [fromDate, setFromDate] = useState();
  // const [toDate, setToDate] = useState();
  const [focusedElement, setFocusedElement] = useState();
  const [myUser, setMyUser] = useState();
  const dispatch = useDispatch();
  const {
    propertyList,
    totalCount,
    feildsList,
    filtersList,
    inputs,
    fromDate,
    toDate,
    tableSort,
  } = useSelector((state) => state.propertyData);

  const handleFocus = (name) => {
    setFocusedElement(name);
  };

  const handleEvent = (event, picker) => {
    // setFromDate(picker.startDate._d.toISOString());
    // setToDate(picker.endDate._d.toISOString());
    dispatch(
      saveSelectedDate(
        picker.startDate._d.toISOString(),
        picker.endDate._d.toISOString()
      )
    );
    dispatch(
      getAllProperties(
        setErrorAlert,
        pagination,
        inputs,
        tableSort,
        moment(picker.startDate._d.toISOString()).format("YYYY-MM-DD"),
        moment(picker.endDate._d.toISOString()).format("YYYY-MM-DD")
      )
    );
  };

  useEffect(() => {
    if (
      fromDate !== undefined &&
      toDate !== undefined &&
      fromDate !== null &&
      toDate !== null
    ) {
      setSelectedDate(
        `${moment(fromDate).format("YYYY-MM-DD")} to ${moment(toDate).format(
          "YYYY-MM-DD"
        )}`
      );
    }
  }, [fromDate, toDate]);

  const handleBlur = () => {
    setFocusedElement(null);
  };

  const handleChange = async (field, value, list) => {
    
    if (value?.includes("all")) {
      if (inputs[field].length === list.length) {
        // setInputs({ ...inputs, [field]: [] });
        dispatch(saveInputFilter({ ...inputs, [field]: [] }));
        return;
      }

      let data;
      if (
        field === "location" ||
        field === "city" ||
        field === "area" ||
        field === "status"
      ) {
        data = await list.map((item) => item);
      } else if (field === "user") {
        data = value;
      } else {
        data = await list.map((item) => item._id);
      }
      
      // setInputs({ ...inputs, [field]: data });
      dispatch(saveInputFilter({ ...inputs, [field]: data }));
      return;
    }
    // setInputs({ ...inputs, [field]: value });
    dispatch(saveInputFilter({ ...inputs, [field]: value }));
  };

  const handleChangePagination = (e, count) => {
    setPagination(count);
  };

  function handleGetPropertyList(filters,clear) {

    dispatch(
      getAllProperties(
        setErrorAlert,
        pagination,
        filters,
        tableSort,
        clear ? null : fromDate && moment(fromDate).format("YYYY-MM-DD"),
        clear ? null : toDate && moment(toDate).format("YYYY-MM-DD")
      )
    );
  }

  useEffect(() => {
    handleGetPropertyList(inputs);
  }, [pagination, tableSort]);

  useEffect(() => {
    dispatch(getFeildsList(setErrorAlert));
    dispatch(getAllFiltersList(setErrorAlert));
  }, []);

  const handleNext = () => {
    handleGetPropertyList(inputs);
  };

  const handleClearFilter = async () => {
    const filter = {
      category: [],
      property_type: [],
      location: [],
      city: [],
      posted_by: [],
      area: [],
      price: [],
      status: [],
      owner_type: [],
    };
    setSelectedDate();
    // setFromDate();
    // setToDate();
    dispatch(saveSelectedDate(null, null));
    // setInputs(filter);
    dispatch(saveInputFilter(filter));
    dispatch(saveSortOrder("createdAt-desc"));
    handleGetPropertyList(filter,"clear");
    
  };

  
  return (
    <>
      <Typography className={classes.list_header}>Property List </Typography>
      <Box className={classes.filter_part}>
        <div className={classes.filterHeaderdiv}>
          <Typography className={classes.sub_header}>
            <ListFilterIcon /> Filter
          </Typography>
          <Typography
            className={`${classes.sub_header} ${classes.clearFilterBtn}`}
            onClick={handleClearFilter}
          >
            <FaFilterCircleXmark /> Clear Filter
          </Typography>
        </div>
        <Box mt={2}>
          <ValidatorForm
            useref="form"
            onSubmit={handleNext}
            className={classes.SignUpForm}
          >
            {/* <Box className={classes.filter_list}> */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "category" ||
                        inputs["category"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Category
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "category" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("category")}
                    onBlur={handleBlur}
                    key={"category"}
                    autoComplete="off"
                    select
                    // label="Category"
                    fullWidth
                    id="emailInput"
                    name={"category"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["category"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["category"]
                            ?.map((value) => {
                              const item = feildsList?.offer_type.find(
                                (item) => item?._id === value
                              );
                              return item?.text;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["category"]}
                    onChange={(e) =>
                      handleChange(
                        "category",
                        e.target.value,
                        feildsList?.offer_type
                      )
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["category"]?.length ===
                          feildsList?.offer_type?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["category"]?.length ===
                          feildsList?.offer_type?.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {feildsList?.offer_type?.map((item) => (
                      <MenuItem
                        value={item?._id}
                        key={item?._id}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["category"]?.includes(item?._id)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["category"]?.includes(item?._id) &&
                            classes.checkboxText
                          }`}
                        >
                          {item?.text}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"category"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  fullWidth
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"category"}
                  value={inputs["category"]}
                  onChange={(e) => handleChange("category", e.target.value)}
                  size="normal"
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Category</p>
                  </MenuItem>
                  {feildsList?.offer_type.map((item, index) => (
                    <MenuItem value={item._id} key={index}>
                      {" "}
                      {item.text}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "property_type" ||
                        inputs["property_type"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Property Type
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "property_type" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("property_type")}
                    onBlur={handleBlur}
                    key={"property_type"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="emailInput"
                    placeholder="Expected by"
                    name={"property_type"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["property_type"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["property_type"]
                            ?.map((value) => {
                              const item = feildsList?.property_type.find(
                                (item) => item?._id === value
                              );
                              return item?.text;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["property_type"]}
                    onChange={(e) =>
                      handleChange(
                        "property_type",
                        e.target.value,
                        feildsList?.property_type
                      )
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["property_type"]?.length ===
                          feildsList?.property_type?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["property_type"]?.length ===
                          feildsList?.property_type?.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {feildsList?.property_type?.map((item) => (
                      <MenuItem
                        value={item?._id}
                        key={item?._id}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["property_type"]?.includes(item?._id)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["property_type"]?.includes(item?._id) &&
                            classes.checkboxText
                          }`}
                        >
                          {item?.text}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                  {/* <TextValidator
                  key={"property_type"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  fullWidth
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"property_type"}
                  value={inputs["property_type"]}
                  size="normal"
                  onChange={(e) =>
                    handleChange("property_type", e.target.value)
                  }
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Property type</p>
                  </MenuItem>
                  {feildsList?.property_type.map((item, index) => (
                    <MenuItem value={item._id} key={index}>
                      {" "}
                      {item.text}
                    </MenuItem>
                  ))}
                </TextValidator> */}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "location" ||
                        inputs["location"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Location
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "location" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("location")}
                    onBlur={handleBlur}
                    key={"location"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="emailInput"
                    placeholder="Expected by"
                    name={"location"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["location"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["location"]
                            ?.map((value) => {
                              const item = filtersList?.location.find(
                                (item) => item === value
                              );
                              return item;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["location"]}
                    onChange={(e) =>
                      handleChange(
                        "location",
                        e.target.value,
                        filtersList?.location
                      )
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["location"]?.length ===
                          filtersList?.location?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["location"]?.length ===
                          filtersList?.location?.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {filtersList?.location?.map((item) => (
                      <MenuItem
                        value={item}
                        key={item}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["location"]?.includes(item)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["location"]?.includes(item) &&
                            classes.checkboxText
                          }`}
                        >
                          {item}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                  {/* <TextValidator
                  key={"location"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  id="emailInput"
                  fullWidth
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"location"}
                  value={inputs["location"]}
                  size="normal"
                  onChange={(e) => handleChange("location", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Location</p>
                  </MenuItem>
                  {filtersList?.location.map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {item}
                    </MenuItem>
                  ))}
                </TextValidator> */}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "city" ||
                        inputs["city"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    City
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "city" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("city")}
                    onBlur={handleBlur}
                    key={"city"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="city"
                    placeholder="Expected by"
                    name={"city"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["city"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["city"]
                            ?.map((value) => {
                              const item = filtersList?.city.find(
                                (item) => item === value
                              );
                              return item;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["city"]}
                    onChange={(e) =>
                      handleChange("city", e.target.value, filtersList?.city)
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["city"]?.length === filtersList?.city?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["city"]?.length === filtersList?.city.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {filtersList?.city?.map((item) => (
                      <MenuItem
                        value={item}
                        key={item}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["city"]?.includes(item)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["city"]?.includes(item) &&
                            classes.checkboxText
                          }`}
                        >
                          {item}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"city"}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  select
                  id="emailInput"
                  placeholder="Expected by"
                  className={`${classes.selectInput} my-field select-field`}
                  name={"city"}
                  value={inputs["city"]}
                  size="normal"
                  onChange={(e) => handleChange("city", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>City</p>
                  </MenuItem>
                  {filtersList?.city.map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {item}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "posted_by" ||
                        inputs["posted_by"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Posted By
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "posted_by" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("posted_by")}
                    onBlur={handleBlur}
                    key={"posted_by"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="posted_by"
                    placeholder="Expected by"
                    name={"posted_by"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["posted_by"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["posted_by"]
                            ?.map((value) => {
                              const item = feildsList?.user_type.find(
                                (item) => item._id === value
                              );
                              return item.text;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["posted_by"]}
                    onChange={(e) =>
                      handleChange(
                        "posted_by",
                        e.target.value,
                        feildsList?.user_type
                      )
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["posted_by"]?.length ===
                          feildsList?.user_type?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["posted_by"]?.length ===
                          feildsList?.user_type.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {feildsList?.user_type?.map((item) => (
                      <MenuItem
                        value={item?._id}
                        key={item?._id}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["posted_by"]?.includes(item?._id)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["posted_by"]?.includes(item?._id) &&
                            classes.checkboxText
                          }`}
                        >
                          {item?.text}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"posted_by"}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  select
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"posted_by"}
                  value={inputs["posted_by"]}
                  size="normal"
                  onChange={(e) => handleChange("posted_by", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Posted By</p>
                  </MenuItem>
                  {feildsList?.user_type.map((item, index) => (
                    <MenuItem value={item._id} key={index}>
                      {" "}
                      {item.text}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "area" ||
                        inputs["area"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Area{" "}
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "area" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("area")}
                    onBlur={handleBlur}
                    key={"area"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="area"
                    placeholder="Expected by"
                    name={"area"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["area"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["area"]
                            ?.map((value) => {
                              const item = filtersList?.area.find(
                                (item) => item === value
                              );
                              return item;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["area"]}
                    onChange={(e) =>
                      handleChange("area", e.target.value, filtersList?.area)
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["area"]?.length === filtersList?.area?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["area"]?.length === filtersList?.area.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {filtersList?.area?.map((item) => (
                      <MenuItem
                        value={item}
                        key={item}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["area"]?.includes(item)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["area"]?.includes(item) &&
                            classes.checkboxText
                          }`}
                        >
                          {item}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"area"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  fullWidth
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"area"}
                  value={inputs["area"]}
                  size="normal"
                  onChange={(e) => handleChange("area", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Area</p>
                  </MenuItem>
                  {filtersList?.area.map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {item}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "status" ||
                        inputs["status"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Status{" "}
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "status" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("status")}
                    onBlur={handleBlur}
                    key={"status"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="status"
                    placeholder="Expected by"
                    name={"status"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["status"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["status"]
                            ?.map((value) => {
                              const item = statusList?.find(
                                (item) => item === value
                              );
                              return item;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["status"]}
                    onChange={(e) =>
                      handleChange("status", e.target.value, statusList)
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["status"]?.length === statusList?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["status"]?.length === statusList?.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {statusList?.map((item) => (
                      <MenuItem
                        value={item}
                        key={item}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["status"]?.includes(item)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["status"]?.includes(item) &&
                            classes.checkboxText
                          }`}
                        >
                          {item.replace("_", " ")}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"status"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  fullWidth
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"status"}
                  value={inputs["status"]}
                  size="normal"
                  onChange={(e) => handleChange("status", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Status</p>
                  </MenuItem>
                  {statusList?.map((item, index) => (
                    <MenuItem value={item} key={index}>
                      {" "}
                      {item.replace("_", " ")}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth className="form-c">
                  <InputLabel
                    id="demo-simple-select-label"
                    className={`${classes.InputLabel} ${
                      (focusedElement === "owner_type" ||
                        inputs["owner_type"]?.length > 0) &&
                      classes.focuedValueLable
                    }`}
                  >
                    Owner Type
                  </InputLabel>
                  <Select
                    variant="outlined"
                    className={`${classes.selectInput} ${
                      focusedElement === "owner_type" && classes.focusedInput
                    }`}
                    onFocus={() => handleFocus("owner_type")}
                    onBlur={handleBlur}
                    key={"owner_type"}
                    autoComplete="off"
                    select
                    fullWidth
                    id="emailInput"
                    placeholder="Expected by"
                    name={"owner_type"}
                    size="normal"
                    multiple
                    renderValue={(selected) => {
                      if (inputs["owner_type"]?.length === 0) {
                        return (
                          <em style={{ color: "rgba(0,0,0,0.3)" }}>Category</em>
                        );
                      }
                      return (
                        <em style={{ textTransform: "capitalize" }}>
                          {inputs["owner_type"]
                            ?.map((value) => {
                              const item = feildsList?.ownership.find(
                                (item) => item?._id === value
                              );
                              return item?.text;
                            })
                            .join(", ")}
                        </em>
                      );
                    }}
                    value={inputs["owner_type"]}
                    onChange={(e) =>
                      handleChange(
                        "owner_type",
                        e.target.value,
                        feildsList?.ownership
                      )
                    }
                    validators={["required"]} // Add this line
                    errorMessages={["Amenities is required"]} // Add this line
                  >
                    <MenuItem
                      value={"all"}
                      className={`${classes.CheckBoxContainer} ${
                        inputs["owner_type"]?.length ===
                          feildsList?.ownership?.length &&
                        classes.CheckBoxActiveSelectAllContainer
                      }`}
                    >
                      <Checkbox
                        sx={{ padding: 0 }}
                        color="primary"
                        checked={
                          inputs["owner_type"]?.length ===
                          feildsList?.ownership?.length
                        }
                        classes={{
                          checked: classes.checked,
                        }}
                      />
                      <span>Select All</span>
                    </MenuItem>
                    {feildsList?.ownership?.map((item) => (
                      <MenuItem
                        value={item?._id}
                        key={item?._id}
                        className={classes.CheckBoxContainer}
                      >
                        <Checkbox
                          sx={{ padding: 0 }}
                          color="primary"
                          checked={inputs["owner_type"]?.includes(item?._id)}
                          classes={{
                            checked: classes.checked,
                          }}
                        />
                        <span
                          className={`${
                            inputs["owner_type"]?.includes(item?._id) &&
                            classes.checkboxText
                          }`}
                        >
                          {item?.text}
                        </span>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {/* <TextValidator
                  key={"owner_type"}
                  variant="outlined"
                  autoComplete="off"
                  select
                  id="emailInput"
                  placeholder="Expected by"
                  className={`my-field select-field`}
                  name={"owner_type"}
                  fullWidth
                  value={inputs["owner_type"]}
                  size="normal"
                  onChange={(e) => handleChange("owner_type", e.target.value)}
                >
                  <MenuItem value={"-1"}>
                    <p style={{ color: "rgba(0,0,0,0.3)" }}>Owner type</p>
                  </MenuItem>
                  {feildsList?.ownership.map((item, index) => (
                    <MenuItem value={item._id} key={index}>
                      {" "}
                      {item.text}
                    </MenuItem>
                  ))}
                </TextValidator> */}
              </Grid>
              <Grid item xs={12} sm={6} md={2}>
                <FormControl fullWidth>
                  {/* <InputLabel
                    id="demo-simple-select-label"
                    // className={`${classes.InputLabel} ${
                    //   (focusedElement === "owner_type" ||
                    //     inputs["owner_type"]?.length > 0) &&
                    //   classes.focuedValueLable
                    // }`}
                  >
                    User List
                  </InputLabel> */}
                  <Autocomplete
                    id="free-solo-demo"
                    // freeSolo
                    value={inputs["user"]}
                    onChange={(event, value) => {
                      handleChange(
                        "user",
                        value ? value : "",
                        feildsList?.ownership
                      );
                      // setMyUser(value);
                    }}
                    onFocus={() => handleFocus("myuser")}
                    onBlur={handleBlur}
                    options={
                      filtersList &&
                      filtersList?.userList &&
                      filtersList?.userList?.length > 0
                        ? filtersList?.userList?.map((option) => option)
                        : [].map((option) => option)
                    }
                    renderInput={(params) => (
                      <TextField
                        label="User"
                        // placeholder="Select City"
                        className={
                          focusedElement === "myuser"
                            ? "my-autocomplete-focus my-autocomplete"
                            : "my-autocomplete"
                        }
                        {...params}
                      />
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Button className={classes.search_btn} type="submit">
              <WhiteSearchIcon /> Search
            </Button>
          </ValidatorForm>
        </Box>
      </Box>
      <Box className={classes.table_part}>
        <MyTableContainer
          arr={arr}
          tableDatas={propertyList}
          handleChangePagination={handleChangePagination}
          totalCount={totalCount}
          handleEvent={handleEvent}
          selectedDate={selectedDate}
          handleGetPropertyList={handleGetPropertyList}
        />
      </Box>
    </>
  );
};

export default PropertyIndex;
